<div class="backIcon">
  <mat-icon class="close-icon" [routerLink]="['/private-space/view-properties']"
    >close</mat-icon
  >
</div>

<div class="text-center mat-header">Edit a Property</div>
<div class="form-group col-sm-12 text-center" *ngIf="isLoading">
  <img
    class="loader"
    src="../../assets/images/loader.gif"
    width="60px"
    alt=""
  />
</div>
<mat-card-content *ngIf="!isLoading">
  <form
    [formGroup]="editPropertyForm"
    (ngSubmit)="onEditNewProperty()"
    class="row g-3 needs-validation"
  >
    <div class="form-group col-sm-12">
      <label for="name">Property Name</label>
      <input
        class="form-control"
        id="name"
        formControlName="name"
        required
        type="text"
        value=""
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.name.touched) &&
        editPropertyForm.controls.name.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-6">
      <label for="status">Status</label>
      <select
        class="form-control"
        id="status"
        formControlName="status"
        required
      >
        <option value="">Choose...</option>
        <option>NEW</option>
        <option>ACTIVE</option>
        <option>INACTIVE</option>
        <option>PUBLISHED</option>
      </select>
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.status.touched) &&
        editPropertyForm.controls.status.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-6">
      <label for="type">Property Type</label>
      <input
        class="form-control"
        id="type"
        formControlName="type"
        required
        type="text"
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.type.touched) &&
        editPropertyForm.controls.type.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-12">
      <label for="industry">industry</label>
      <input
        class="form-control"
        id="industry"
        formControlName="industry"
        required
        type="text"
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.industry.touched) &&
        editPropertyForm.controls.industry.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-6">
      <label for="noOfDays">No. of days</label>
      <input
        class="form-control"
        type="text"
        id="noOfDays"
        name="noOfDays"
        formControlName="noOfDays"
        required
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.noOfDays.touched) &&
        editPropertyForm.controls.noOfDays.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-6">
      <label for="onSiteAttendance">No. site attendance</label>
      <input
        class="form-control"
        type="text"
        id="onSiteAttendance"
        name="onSiteAttendance"
        formControlName="onSiteAttendance"
        required
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.onSiteAttendance.touched) &&
        editPropertyForm.controls.onSiteAttendance.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-6">
      <label for="eventSite">Event Site</label>
      <input
        class="form-control"
        id="eventSite"
        formControlName="eventSite"
        required
        type="text"
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.eventSite.touched) &&
        editPropertyForm.controls.eventSite.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-6">
      <label for="category">Category</label>
      <input
        class="form-control"
        id="category"
        formControlName="category"
        required
        type="text"
      />
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.category.touched) &&
        editPropertyForm.controls.category.errors?.required
      "
      >Please fill</span
    >
    </div>

    <div class="form-group col-sm-12">
      <label for="description">Description</label>
      <!-- <input class="form-control"  id="description" formControlName="description" required type="text"/> -->
      <textarea
        class="form-control"
        aria-label="Property description"
        id="description"
        formControlName="description"
        required
      ></textarea>
      <span
      class="validation-error"
      *ngIf="
        (customStylesValidated || editPropertyForm.controls.description.touched) &&
        editPropertyForm.controls.description.errors?.required
      "
      >Please fill</span
    >
    </div>
    <div class="form-group col-sm-12 text-center" *ngIf="loading">
      <img
        class="loader"
        src="../../assets/images/loader.gif"
        width="60px"
        alt=""
      />
    </div>
    <div class="form-group col-sm-12">
      <button
        style="background-color: rgba(74, 116, 54, 255); color: #fff"
        class="btn btn-success"
        type="submit"
      >
        Submit form
      </button>
      <button
        style="background-color: black; color: #fff"
        class="btn"
        type="reset"
      >
        Reset
      </button>
      <div class="text-center">
        <!-- <c-spinner *ngIf="isLoading" class="spinner" color="dark" variant="grow"></c-spinner> -->
      </div>
    </div>
  </form>
</mat-card-content>
